import { useIntl } from 'react-intl'

/**
 * Returns a localised property category label for homes & villas.
 *
 * To add a new prefixed category, add the ENTIRE translated phrase
 * (e.g. "Entire treehouse") as a new `case` below.
 * Do NOT try to concatenate a translated "Entire" prefix with the category —
 * other languages have different grammar, word order, and gender agreement
 * that make prefix concatenation unreliable.
 */
function usePropertyCategory(category?: string): string {
  const intl = useIntl()

  switch (category) {
    case 'Cabin':
      return intl.formatMessage({
        id: 'L6hwAU1MBcxdNtPKVO60',
        defaultMessage: 'Entire cabin',
      })
    case 'Campsite':
      return intl.formatMessage({
        id: '7mtGZE3Y6ZmIy3msqoUk',
        defaultMessage: 'Entire campsite',
      })
    case 'Chalet':
      return intl.formatMessage({
        id: 'T-wkH3VqFTygg5PiEGZ4',
        defaultMessage: 'Entire chalet',
      })
    case 'Condominium':
      return intl.formatMessage({
        id: '1vgTPLsv2-mxp7wxfUlH',
        defaultMessage: 'Entire condominium',
      })
    case 'Country House':
      return intl.formatMessage({
        id: 'YvhfHB0pWF4UunoavJsV',
        defaultMessage: 'Entire country house',
      })
    case 'Guesthouse':
      return intl.formatMessage({
        id: 'gcrSayDt9UGIZ6mEx1i7',
        defaultMessage: 'Entire guesthouse',
      })
    case 'Apartment':
      return intl.formatMessage({
        id: 'BOLOk_kBxWInBqXTLV84',
        defaultMessage: 'Entire apartment',
      })
    case 'Private vacation home':
      return intl.formatMessage({
        id: 'FC2DdBGOaRRuz1EIAD-J',
        defaultMessage: 'Entire private vacation home',
      })
    case 'Villa':
      return intl.formatMessage({
        id: 'nPwjbi9wGUIlsOB87O2C',
        defaultMessage: 'Entire villa',
      })
    case 'Castle':
      return intl.formatMessage({
        id: 'mV37fLXSekwoMzoPTYtZ',
        defaultMessage: 'Entire castle',
      })
    default:
      if (category) return category
      return intl.formatMessage({
        id: 'bWZRSRX8cyVWjqjZss6_',
        defaultMessage: 'Entire villa',
      })
  }
}

export default usePropertyCategory
